import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {
  injectIntl,
  FormattedDate as FormattedDateOriginal
} from 'react-intl'
import moment from 'moment'
import styles from './formatted-date.styl'

@injectIntl
class FormattedDate extends Component {
  static propTypes = {
    value: PropTypes.any.isRequired,
    intl: PropTypes.object,
    spaceAfter: PropTypes.bool
  }

  render() {
    const {
      value,
      intl,
      spaceAfter
    } = this.props
    const isArabic = intl.locale === 'ar'
    const spaceAfterClass = isArabic && spaceAfter ? styles.arabicSpaceAfter : ''

    return (
      <span className={`${spaceAfterClass}`}>
        { isArabic && moment(value).format('L') }
        { !isArabic && <FormattedDateOriginal {...this.props} /> }
      </span>
    )
  }
}

export default FormattedDate
